export default __webpack_public_path__ + "static/media/project3.93226f1a.png";